import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import { ROLL_CALL_API_BASE_URL } from "../../../RollCall/RollCallConfig/RollCallConfig";
import { Select, Spin } from "antd";

const EditKpiMetricDetails = ({
  editObj,
  fetchMetricDetails,
  onClose,
  isOpen,
}) => {
  const [editObjData, setEditObjData] = useState(editObj);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [loading, setloading] = useState(false);
  const [kpiGroups, setKpiGroups] = useState([]);
  const [metrics, setMetrics] = useState([]);
  const [metricsLoading, setMetricsLoading] = useState(false);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
    }
  }, []);

  console.log(editObjData, "editObjData");
  useEffect(() => {
    if (editObj) {
      setEditObjData(editObj);
    }
  }, [editObj]);

  useEffect(() => {
    if (editObjData?.KPIGroupId) {
      fetchMetrics(editObjData?.KPIGroupId);
    } else {
      setMetrics([]);
    }
  }, [editObjData?.KPIGroupId]);

  useEffect(() => {
    const getKpiGroups = async () => {
      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/kpi/getKPIGroups?KPIGroupId=0&SuperId=${superIdData}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${tokenData}`,
            },
          },
        );

        const data = await response.json();

        if (data?.status) {
          setKpiGroups(data.ResultData);
        }
      } catch (error) {
        console.log("Error fetching KPI Groups:", error);
      }
    };

    getKpiGroups();
  }, [tokenData]);

  const fetchMetrics = async (kpiGroup) => {
    if (!tokenData || !superIdData || !kpiGroup) return;

    setMetricsLoading(true);
    try {
      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/kpi/getkpimetrics?KPIGroup=${editObjData?.KPIGroupId}&SuperId=${superIdData}&BranchId=0`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${tokenData}`,
          },
        },
      );

      const data = await response.json();

      if (data?.status && Array.isArray(data.ResultData)) {
        const options = data.ResultData.map((item) => ({
          label: item.Title,
          value: item.id,
        }));
        setMetrics(options);
      } else {
        setMetrics([]);
      }
    } catch (error) {
      console.error("Error fetching metrics:", error);
      setMetrics([]);
      Swal.fire("Error", "Failed to load metrics", "error");
    } finally {
      setMetricsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setEditObjData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setloading(true);
    const payload = {
      Id: editObjData?.Id,
      MetricId: editObjData?.MetricId,
      Title: editObjData?.Title,
      Description: editObjData?.Description,
      BranchId: editObjData?.BranchId || 0,
    };

    try {
      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/kpi/updateKpiMetricDetails`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenData}`,
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      if (data?.status) {
        Swal.fire("Success", "KPI Metric updated successfully", "success");

        fetchMetricDetails();
        onClose();
      } else {
        Swal.fire(
          "Error",
          data?.message || "Failed to update KPI Metric",
          "error",
        );
      }
    } catch (error) {
      console.error("Update Error:", error);

      Swal.fire("Error", "Something went wrong", "error");
    } finally {
      setloading(false);
    }
  };

  return (
    <>
      {isOpen && (
        <div>
          {loading && (
            <div
              className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
              style={{
                zIndex: 1050,
                backdropFilter: "blur(4px)",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
              }}
            >
              <Spin size="large" tip="Processing..." />
            </div>
          )}

          <style>
            {`
        @media (max-width: 576px) {
          #offcanvasRightEditKpiMetricDetails {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightEditKpiMetricDetails {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightEditKpiMetricDetails {
            width: 32% !important;
          }
        }
          
       @media (min-width: 1441px) and (max-width:2550px) {
          #offcanvasRightEditKpiMetricDetails {
            width: 20% !important;
          }
        }
        @media (min-width:2551px) {
          #offcanvasRightEditKpiMetricDetails {
            width:15% !important;
          }
        }
        `}
          </style>

          {/* Backdrop */}
          <div className="offcanvas-backdrop fade show" onClick={onClose} />

          <div
            className="offcanvas offcanvas-end show"
            id="offcanvasRightEditKpiMetricDetails"
            style={{ visibility: "visible" }}
          >
            <div className="offcanvas-header">
              <h4>Edit Metric Details</h4>
              <button
                type="button"
                className="btn-close text-reset"
                onClick={onClose}
                aria-label="Close"
              />
            </div>
            <hr />
            <div
              className="d-flex flex-column flex-grow-1"
              style={{ overflow: "hidden" }}
            >
              <div className="offcanvas-body" style={{ overflow: "visible" }}>
                <form onSubmit={handleUpdate}>
                  <div className="content">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">
                          <span className="text-danger">*</span> Frequency
                        </label>
                        <Select
                          placeholder="Select KPI Group"
                          style={{ width: "100%" }}
                          value={editObjData?.KPIGroupId}
                          options={kpiGroups?.map((item) => ({
                            label: item.Name,
                            value: item.ID,
                          }))}
                          onChange={(value, option) => {
                            setEditObjData((prev) => ({
                              ...prev,
                              KPIGroupId: value,
                              KPIGroupName: option.label,
                              MetricId: null,
                            }));
                          }}
                        />
                      </div>

                      {/* Metric Dropdown (Dynamic) */}
                      <div className="col-md-6 mb-3">
                        <label className="form-label">
                          <span className="text-danger">*</span> Metric
                        </label>
                        <Select
                          className="w-100"
                          placeholder="Select Metric"
                          value={editObjData?.MetricId || undefined}
                          onChange={(value) =>
                            setEditObjData((prev) => ({
                              ...prev,
                              MetricId: value,
                            }))
                          }
                          options={metrics}
                          loading={metricsLoading}
                          disabled={metricsLoading}
                        />
                      </div>

                      {/* Title */}
                      <div className="col-12 mb-3">
                        <label className="form-label">
                          <span className="text-danger">*</span> Title
                        </label>
                        <input
                          type="text"
                          name="Title"
                          className="form-control"
                          placeholder="Enter title"
                          value={editObjData?.Title}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      {/* Description */}
                      <div className="col-12 mb-3">
                        <label className="form-label">
                          <span className="text-danger">*</span> Description
                        </label>
                        <textarea
                          name="Description"
                          className="form-control"
                          placeholder="Enter description"
                          rows={3}
                          value={editObjData?.Description}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>

                    <div className="row d-flex justify-content-end mt-3">
                      <div
                        className="col-3 d-flex justify-content-end"
                        style={{ marginRight: "20px" }}
                      >
                        <button
                          type="button"
                          className="btn btn-secondary "
                          onClick={onClose}
                          aria-label="Close"
                        >
                          Cancel
                        </button>
                      </div>
                      <div className="col-2 d-flex justify-content-end">
                        <button type="submit" className="btn btn-success">
                          {" "}
                          {loading ? " Saving.." : "Update"}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

EditKpiMetricDetails.propTypes = {
  editObj: PropTypes.object.isRequired,
  fetchMetricDetails: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.func.isRequired,
};

export default EditKpiMetricDetails;
